import SiderMenu from './SiderMenu';

export default SiderMenu;